// Copyright 2016 Sorama B.V.

export enum CreditMutationType {
    Spectrum,
    Beamforming,
    NearField,
}

export class CreditsDebetAction {
    amount: number;
    describtion: string;
    creditDebetType: CreditMutationType;
    mergable: boolean;
}
